// extracted by mini-css-extract-plugin
export default {"whoWeAreHeader":"WhoWeAre_whoWeAreHeader__tKaQ+"};